import { t } from 'i18next'
import * as Yup from 'yup'
import { setLocale } from 'yup'

import { requiredBillingAddressTypes } from '~/modules/retailMedia/pages/walltets/recharge/dtos/constants'

setLocale({
  mixed: {
    default: t('rm:fieldInvalid'),
    required: t('rm:fieldRequired')
  },
  string: {
    email: t('rm:invalidEmail')
  }
})

const paymentMethods = ['pix', 'credit_card', 'marketplace']
// use requiredBillingAddressTypes
const whenPaymentMethod = (value: PaymentMethod) =>
  requiredBillingAddressTypes.includes(value)
    ? Yup.string().required()
    : Yup.string()

const addressValidations = {
  billingAddress: Yup.object().shape({
    city: Yup.string().when('payment_method', whenPaymentMethod),
    neighborhood: Yup.string().when('payment_method', whenPaymentMethod),
    number: Yup.string().when('payment_method', whenPaymentMethod),
    postcode: Yup.string().when('payment_method', whenPaymentMethod),
    region: Yup.string().when('payment_method', whenPaymentMethod),
    street: Yup.string().when('payment_method', whenPaymentMethod)
  })
}

const personValidations = {
  name: Yup.string().required(),
  identificationNumber: Yup.string().required(),
  phone: Yup.string().required(),
  email: Yup.string().email().required()
}

const FormIndustryRechargeSchema = {
  pix: Yup.object().shape({
    publisher_id: Yup.string().required(),

    amount: Yup.string().required(),

    payment_method: Yup.string().oneOf(paymentMethods).required(),

    ...personValidations,
    ...addressValidations
  }),

  credit_card: Yup.object().shape({
    publisher_id: Yup.string().required(),

    amount: Yup.string().required(),

    payment_method: Yup.string().oneOf(paymentMethods).required(),

    ...personValidations,
    ...addressValidations
  }),

  marketplace: Yup.object().shape({
    publisher_id: Yup.string().required(),

    amount: Yup.string().required(),

    payment_method: Yup.string().oneOf(paymentMethods).required(),

    ...personValidations,
    ...addressValidations
  })
}

const FormAddress = Yup.object().shape(addressValidations)
const FormPerson = Yup.object().shape(personValidations)

export { FormIndustryRechargeSchema, FormAddress, FormPerson }
